var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "crumbs-totals" },
        [_vm._t("breadcrumbs"), _vm._v(" "), _vm._t("totals")],
        2
      ),
      _vm._v(" "),
      _vm._t("groupBy"),
      _vm._v(" "),
      _vm._t("pagination"),
      _vm._v(" "),
      _vm._t("annotation-switcher"),
      _vm._v(" "),
      _c("HitsTable", {
        attrs: {
          query: _vm.results.summary.searchParam,
          mainAnnotation: _vm.mainAnnotation,
          otherAnnotations: _vm.shownAnnotationCols,
          detailedAnnotations: _vm.detailedAnnotations,
          depTreeAnnotations: _vm.depTreeAnnotations,
          metadata: _vm.shownMetadataCols,
          sortableAnnotations: _vm.sortableAnnotations,
          dir: _vm.textDirection,
          html: _vm.concordanceAsHtml,
          disabled: _vm.disabled,
          data: _vm.rows,
        },
        on: { changeSort: _vm.changeSort },
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bottom-layout" },
        [
          _vm._t("pagination"),
          _vm._v(" "),
          _c("div", { staticClass: "spacer" }),
          _vm._v(" "),
          _vm._t("sort"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm show-titles",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.showTitles = !_vm.showTitles
                },
              },
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(
                    _vm.showTitles
                      ? _vm.$t("results.table.hide")
                      : _vm.$t("results.table.show")
                  ) +
                  " " +
                  _vm._s(_vm.$t("results.table.titles")) +
                  "\n\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _vm._t("export"),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }